// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/realize/reset.css'
import dataV from '@jiaminghi/data-view'
import VueRouter from 'vue-router'
import App from './App'
import router from './router/index.js'

import axios from 'axios'
// axios 封装
import axiosInstance from './api/axios-instance.js'

import VueAxios from 'vue-axios'
import store from './store/index.js'


axios.defaults.baseURL='https://iot.accutargetmed.com/api'
axios.defaults.timeout = 8000

Vue.prototype.$http = axios
Vue.prototype.$store = store
Vue.prototype.$place = window.place
Vue.prototype.$geo = window.data;
Vue.prototype.$https = axiosInstance;

Vue.use(ElementUI)
Vue.use(dataV)
Vue.use(VueRouter)
Vue.use(VueAxios,axios)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js